import type { ICreateOrderRequestBody } from './typings';

const HEX_RADIX = 16;

/** 与后端约定的 canonical 串；未传字段用空字符串占位，再 SHA256(hex)。 */
export async function hashCreateOrderRequestBodySha256(body: ICreateOrderRequestBody): Promise<string> {
    const activity_id = body.activity_id ?? '';
    const activity_instance_id = body.activity_instance_id ?? '';
    const currency_code = body.client_params?.currency_code ?? '';
    const formatted_string = body.client_params?.formatted_string ?? '';
    const nonce = body.nonce ?? '';
    const paywall_checksum = body.paywall_checksum ?? '';
    const paywall_id_str = body.paywall_id_str ?? '';
    const paywall_version = body.version !== undefined && body.version !== null ? String(body.version) : '';
    const store = body.store ?? '';
    const third_product_id = body.third_product_id ?? '';
    const ts = body.ts !== undefined && body.ts !== null ? String(body.ts) : '';

    const str = `activity_id=${activity_id}&activity_instance_id=${activity_instance_id}&currency=${currency_code}&formatted_string=${formatted_string}&nonce=${nonce}&paywall_checksum=${paywall_checksum}&paywall_id=${paywall_id_str}&paywall_version=${paywall_version}&store=${store}&third_product_id=${third_product_id}&ts=${ts}`;

    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
    return Array.from(new Uint8Array(digest))
        .map(b => b.toString(HEX_RADIX).padStart(2, '0'))
        .join('');
}
